import React, { useEffect, useState } from "react";
import ExamTimer from "./ExamTimer";
import { useSelector } from "react-redux";
import userImg from "../assets/user.png";
import { useNavigate, useParams } from "react-router-dom";

function Header({ user, onLogout }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const totalTime = useSelector((state) => state.test.testTime?.data || 0);
  const totalTimeSuccess = useSelector((state) => state.test.testTime?.success);
  const TestTitle = useSelector(
    (state) => state.test?.testDetails?.data?.TestTitle
  );

  return (
    <header className=" bg-white text-gray-800 pt-4 shadow-lg z-10">
      <div className="container mx-auto flex justify-between items-center relative mb-3">
        <div className="flex items-center">
          <img
            src="https://nxgcreator.s3.ap-south-1.amazonaws.com/ayurGroup%20512.png"
            alt="Logo"
            className="h-10 w-auto mr-4"
            style={{ width: "60px", height: "60px" }}
          />
          <h1 className="text-xl font-bold ">AYUR GUIDE</h1>
        </div>
        <div className="flex items-center gap-3">
          <div className="border flex items-center bg-gray-50 text-gray-300 rounded-lg h-28 w-32">
            <img src={userImg} alt="user" />
          </div>
          <div className="container mx-auto flex flex-col gap-1 my-2">
            <span className="text-lg font-semibold">
              Canditate Name:{" "}
              <span className="text-orange-600 uppercase ml-2">
                {user?.First_name}
              </span>
            </span>
            <span className="text-lg font-semibold">
              Email Address:
              <span className="text-orange-600 uppercase ml-2">
                {user?.Email_id}
              </span>
            </span>
            <span className="text-lg font-semibold">
              Moblie No.:{" "}
              <span className="text-orange-600 uppercase ml-2">
                {user?.Mob_no}
              </span>
            </span>
            {totalTimeSuccess && (
              <span className="text-lg font-semibold flex gap-4">
                Remaining Time:{" "}
                <span className="flex items-center justify-center rounded-lg bg-cyan-500 p-1 w-32">
                  <ExamTimer totalTime={totalTime} />
                </span>
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="flex w-full  bg-orange-400 h-24">
        <div className="container mx-auto flex justify-between items-center relative">
          <span className="text-white font-semibold text-xl">{TestTitle}</span>
          <div className="gap-3 flex">
            {!window?.location?.pathname?.includes("/home") && (
              <button
                onClick={() => navigate("/home")}
                className="text-white font-bold uppercase px-4 py-2 border border-white rounded"
              >
                Home
              </button>
            )}
            {id && (
              <button
                onClick={() => navigate(`/performance/${id}`)}
                className="text-white font-bold uppercase px-4 py-2 border border-white rounded"
              >
                Performance
              </button>
            )}
            <button
              className="px-4 py-2 rounded-md uppercase bg-blue-500 text-white font-semibold hover:bg-blue-600"
              onClick={onLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
